import React, { FC, useCallback, Fragment, memo } from "react";
import Shimmer, { ElementSize } from "src/shared/components/CustomisedShimmer";
import { Select } from "antd";
import { RightOutlined } from "src/icons";
import colors from "src/styles/variables.scss";
import { SelectValue } from "antd/lib/select";
import styled from "@emotion/styled";
import { Aggregation } from "src/shared/models/DetailsModel";
const { Option } = Select;

const DropdownsChain = styled.section`
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  margin-top: 13.5px;
  .ant-select {
    width: 100%;
  }
  .ant-select-selection {
    padding-left: 16px;
    box-sizing: border-box;
  }
  .ant-select-selection-selected-value {
    max-width: 90%;
  }
  .ant-select-dropdown {
    right: 20px !important;
  }
`;

const shimmerBarConfig = [
  {
    height: "100%",
    width: "100%",
    elementSize: ElementSize.LONG,
  },
];

type ChainedDropdownsProps = {
  dropdownDatasources: Array<Aggregation>;
  value: Array<string>;
  onChange: (value: Array<string>) => void;
};

const rightChevronStyle = {
  color: colors.milkyWhite,
  opacity: 0.3,
  margin: "auto 9px",
};

const ChainedDropdowns: FC<ChainedDropdownsProps> = ({ dropdownDatasources, onChange, value }) => {
  const handleSelectOption = useCallback(
    (dropdownIndex) => (val: SelectValue) => {
      const newValue = Array.from(value);
      if (val !== "NULL") {
        newValue[dropdownIndex] = val as string;
      } else {
        /* Clear and disable all the following dropdowns */
        if (dropdownIndex < val.length - 1) {
          for (let i = dropdownIndex; i < val.length - 1; i++) {
            delete newValue[i];
          }
        }
        delete newValue[dropdownIndex];
      }
      onChange(newValue);
    },
    [value, onChange]
  );

  const getDropdownDatasource = (datasources: Array<Aggregation>, index: number) => {
    const tempValues = Array.from(value);
    tempValues.splice(index, 1);
    return datasources.filter((datasourceVal) => !tempValues.includes(datasourceVal.id));
  };

  return (
    <div className="nested-container-item">
      <div className="nested-heading">
        <div className="nested-label">SEE DISTRIBUTION BY </div>
        <div className="nested-icon"> {/* <Icon type="more" /> */}</div>
      </div>
      <DropdownsChain>
        {dropdownDatasources ? (
          [1, 2, 3].map((_, index) => (
            <Fragment key={index}>
              <Select
                // showSearch
                placeholder="select"
                onSelect={handleSelectOption(index)}
                value={value[index] ? value[index] : undefined}
                disabled={index > 0 && !value[index - 1]}
                dropdownMatchSelectWidth={false}
                dropdownClassName={index === 2 ? "chained-dropdown-select-last" : ""}
              >
                {getDropdownDatasource(dropdownDatasources, index).map((item, i) => (
                  <Option key={i} value={item.id}>
                    {item.label}
                  </Option>
                ))}
              </Select>
              {index < 2 && (
                <div style={rightChevronStyle} className="icon">
                  <RightOutlined />
                </div>
              )}
            </Fragment>
          ))
        ) : (
          <Shimmer barsConfig={shimmerBarConfig} className="Shimmer" />
        )}
      </DropdownsChain>
    </div>
  );
};

export default memo(ChainedDropdowns);
